import { FLAG_REVEAL_MAP, IS_DEV } from "@/config/constants";
import TileRepository from "@/game/TileRepository";
import TileEntity from "@/game/entities/TileEntity";
import { type MapMutationAction } from "./useMapActions";

let tr: TileRepository | null = null;

export const createTileRepository = (
	tiles?: Array<MapMutationAction>,
): TileRepository => {
	if (tr) throw new Error("TileRepository already initialized");

	TileEntity.isMounted = false;
	tr = FLAG_REVEAL_MAP ? new TileRepository() : new TileRepository(tiles);
	TileEntity.isMounted = true;

	// @ts-expect-error - missing type in window
	if (!window.tr && IS_DEV) window.tr = tr;

	return tr;
};

export default (): TileRepository => {
	if (!tr) throw new Error("TileRepository not initialized");
	return tr;
};

export const isTilerepositoryInitialized = (): boolean => tr !== null;
